import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.promise.js";
import React from 'react';
import { MultiCombobox } from "./MultiCombobox";
import { isChildOneOfType } from "../../utils";
export var NO_OPTIONS_ITEM = {
  disabled: true,
  label: 'No results found.',
  value: ''
};
export function validateOptionIncluded(option, inputValue, externalFilter) {
  return !inputValue ? true : externalFilter ? externalFilter(option, inputValue) : option.label.toLowerCase().startsWith(inputValue.toLowerCase());
}
export function mapOptionsToGroups(children) {
  var map = new Array();
  React.Children.toArray(children).forEach(function (child) {
    if (isChildOneOfType(child, [MultiCombobox.Option, MultiCombobox.OptionGroup])) {
      recursiveMapOptionsToGroups(child, map);
    }
  });
  return map;
}
export var recursiveMapOptionsToGroups = function recursiveMapOptionsToGroups(child, map, groupValue) {
  var childReactElement = child;
  if (childReactElement.type === MultiCombobox.OptionGroup) {
    React.Children.forEach(childReactElement.props.children, function (child) {
      recursiveMapOptionsToGroups(child, map, childReactElement.props.groupValue);
    });
  } else {
    if (childReactElement.type === MultiCombobox.Option) {
      map.push({
        disabled: childReactElement.props.disabled,
        label: childReactElement.props.label,
        value: childReactElement.props.value,
        groupValue: groupValue
      });
    }
  }
};